export default __webpack_public_path__ + "static/media/twitter.06077747.svg";